import AOS from "aos";
import "aos/dist/aos.css";

/**
 * Plugin client-side untuk inisialisasi AOS (Animate On Scroll) secara shared.
 *
 * Plugin ini dipusatkan di layer `base` karena perilaku inisialisasinya sama
 * untuk seluruh template. Template tetap bebas mengatur animasi melalui
 * atribut `data-aos` di markup, tetapi engine dan policy dasarnya dijaga
 * dari satu tempat agar tidak drift.
 */
export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    AOS.init({
      startEvent: "DOMContentLoaded",
      offset: 80,
      duration: 600,
      easing: "ease-out-cubic",
      once: !import.meta.dev,
      mirror: import.meta.dev,
      anchorPlacement: "top-bottom",
      disable: () =>
        typeof window !== "undefined"
        && window.matchMedia("(prefers-reduced-motion: reduce)").matches,
    });

    window.addEventListener("load", () => AOS.refresh());
  }
});
